import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-ods-modal',
  templateUrl: './ods-modal.component.html',
  styleUrls: ['./ods-modal.component.scss'],
})
export class OdsModalComponent {
  @Input() heading: string;
  @Input() titleId = 'odsModalTitle';
}
